import { render, staticRenderFns } from "./PickupPointMap.vue?vue&type=template&id=72843838&"
import script from "./PickupPointMap.vue?vue&type=script&lang=js&"
export * from "./PickupPointMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports